import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.replace";

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Nick Cattaneo

Description:
*/
import DataType from './DataType';
import getString from '../strings/get-string';
export var dataTypes = {
  // server data types
  ALL: new DataType({
    pattern: '\\s\\S'
  }),
  // any number of any characters
  ALPHA: new DataType({
    pattern: 'a-zA-Z'
  }),
  // abcd
  ALPHA_NUMERIC: new DataType({
    pattern: 'a-zA-Z0-9'
  }),
  // a1b2
  ALPHA_NUMERIC_SPACE: new DataType({
    pattern: 'a-zA-Z0-9 '
  }),
  // a 1 b 2
  ALPHA_NUMERIC_SPECIAL: new DataType({
    pattern: 'a-zA-Z0-9 ~!@#$%^&*()_;=\'"+\\.-'
  }),
  // a1*b2@'"
  ALPHA_NUMERIC_SPECIAL2: new DataType({
    pattern: '-\\./,\'#\\w\\s'
  }),
  // a1*b2@'".-
  ALPHA_SPACE: new DataType({
    pattern: 'a-zA-Z '
  }),
  // a b c d
  ALPHA_SPECIAL: new DataType({
    pattern: 'a-zA-Z ~!@#$%^&*()_;=\'"+-'
  }),
  // a*b@
  BOOLEAN: new DataType({
    pattern: '(true|false)'
  }),
  // true/false
  NUMERIC: new DataType({
    pattern: '0-9'
  }),
  // 1234
  NUMERIC_DECIMAL: new DataType({
    pattern: '0-9\\.'
  }),
  // 12.32.33.22
  NUMERIC_SPECIAL: new DataType({
    pattern: '0-9\\/\\-\\.'
  }),
  // 1/2-3
  // special format data types
  DATE_MM_YY: new DataType({
    length: 5,
    regex: /^(0[1-9]|1[0-2])\/\d{2}$/
  }),
  // 01/17
  DATE_MM_DD_YYYY: new DataType({
    length: 10,
    regex: /^(0[1-9]|1[0-2])\/([0-2][0-9]|3[0-1])\/(19\d{2}|20(0|1|2)[0-9])$/
  }),
  // 01/01/2017 (MM_DD_YYYY)
  DATE_DD_MM_YYYY: new DataType({
    length: 10,
    regex: /^([0-2][0-9]|3[0-1])-(0[1-9]|1[0-2])-(19\d{2}|20(0|1|2)[0-9])$/
  }),
  // 01/01/2017 (DD_MM_YYYY) CCSSP - dsf date format
  DOLLAR_NUMERAL: new DataType({
    regex: /^[0-9,$]*$/
  }),
  // $111,222
  DOLLAR_NUMERAL_DECIMAL: new DataType({
    regex: /^[0-9,.$]*$/
  }),
  // $111,222.00
  EMAIL: new DataType({
    regex: /^[0-9a-zA-Z_-]+(\.[0-9a-zA-Z_-]+)*@([0-9a-zA-Z]+[0-9a-zA-Z-]*\.)+[a-zA-Z]+$/
  }),
  // abcd@abcd.com
  EMPLOYER_IDENTIFICATION_NUMBER: new DataType({
    length: 10,
    regex: /^\d{2}-\d{7}$/
  }),
  // 12-3456789
  NUMERAL_DECIMAL: new DataType({
    regex: /^[0-9,.]*$/
  }),
  // 111,222.00
  NUMERAL: new DataType({
    regex: /^[0-9,]*$/
  }),
  // 111,222
  PERCENTAGE: new DataType({
    regex: /^[0-9]*%$/
  }),
  // 12%
  PERCENTAGE_DECIMAL: new DataType({
    regex: /^[0-9.]*$/
  }),
  // 0.00%
  PHONE: new DataType({
    length: 13,
    regex: /^\(\d{3}\)\d{3}-\d{4}$/
  }),
  // (415)222-1567
  SSN: new DataType({
    length: 11,
    regex: /^\d{3}-\d{2}-\d{4}$/
  }) // 123-45-6789

};
export var getMaskLength = function getMaskLength(maskType) {
  return dataTypes[maskType].length;
};
export var masks = ['DATE_MM_YY', 'DATE_MM_DD_YYYY', 'DATE_DD_MM_YYYY', 'EMPLOYER_IDENTIFICATION_NUMBER', 'PHONE', 'SSN'];
export var validateString = function validateString(value) {
  return (value || '').toString();
};
export var formatCharacters = /(\.|,|\/|-|\(|\))/g;
export var addFormatCharacterLength = function addFormatCharacterLength(value) {
  return (validateString(value).match(formatCharacters) || []).length;
};
export var removeFormatting = function removeFormatting(dataType, value) {
  switch (dataType) {
    case 'DATE_MM_YY':
    case 'DATE_MM_DD_YYYY':
    case 'DATE_DD_MM_YYYY':
    case 'DOLLAR_NUMERAL':
    case 'EMPLOYER_IDENTIFICATION_NUMBER':
    case 'NUMERAL':
    case 'PERCENTAGE':
    case 'PHONE':
    case 'SSN':
      return dataTypes.NUMERIC.strip(value);

    case 'PERCENTAGE_DECIMAL':
    case 'NUMERAL_DECIMAL':
      return dataTypes.NUMERIC_DECIMAL.strip(value);

    case 'EMAIL':
      return dataTypes.ALPHA_NUMERIC_SPECIAL.strip(value);

    default:
      return dataTypes[dataType].strip(value);
  }
};
export var addFormatting = function addFormatting(dataType, value) {
  switch (dataType) {
    case 'DATE_MM_YY':
      {
        var $value = value.replace(/[^\d]/g, '').replace(/^(\d{2})/, '$1/').replace(/^(\d{2}\/\d{2})/, '$1');
        return $value.length > 0 ? $value + '__/__'.substring($value.length) : $value;
      }

    case 'DATE_MM_DD_YYYY':
      {
        var _$value = value.replace(/[^\d]/g, '').replace(/^(\d{2})/, '$1/').replace(/^(\d{2}\/\d{2})/, '$1/');

        return _$value.length > 0 ? _$value + '__/__/____'.substring(_$value.length) : _$value;
      }

    case 'DATE_DD_MM_YYYY':
      {
        var _$value2 = value.replace(/[^\d]/g, '').replace(/^(\d{2})/, '$1-').replace(/^(\d{2}-\d{2})/, '$1-');

        return _$value2.length > 0 ? _$value2 + '__-__-____'.substring(_$value2.length) : _$value2;
      }

    case 'DOLLAR_NUMERAL':
      {
        var _$value3 = '$' + value.replace(/[^\d]/g, '').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

        return _$value3.length === 1 ? '' : _$value3;
      }

    case 'DOLLAR_NUMERAL_DECIMAL':
      {
        var _$value4 = '$' + value.replace(/[^\d]/g, '').replace(/(\d{1})(\d{2})$/, '$1.$2').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

        return _$value4.length === 1 ? '' : _$value4;
      }

    case 'EMPLOYER_IDENTIFICATION_NUMBER':
      {
        var _$value5 = value.replace(/[^\d]/g, '').replace(/^(\d{2})/, '$1-');

        return _$value5.length > 0 ? _$value5 + '__-_______'.substring(_$value5.length) : _$value5;
      }

    case 'PERCENTAGE':
      return value.replace(/[^\d]/g, '') + ' %';

    case 'PHONE':
      {
        var _$value6 = value.replace(/[^\d]/g, '').replace(/^(\d{3})/, '$1)').replace(/^(\d{3}\))(\d{3})/, '$1$2-');

        return _$value6.length > 0 ? '(' + _$value6 + '___)___-____'.substring(_$value6.length) : _$value6;
      }

    case 'SSN':
      {
        var _$value7 = value.replace(/[^\d]/g, '').replace(/^(\d{3})/, '$1-').replace(/^(\d{3}-\d{2})/, '$1-');

        return _$value7.length > 0 ? _$value7 + '___-__-____'.substring(_$value7.length) : _$value7;
      }

    case 'PERCENTAGE_DECIMAL':
    case 'NUMERAL_DECIMAL':
      return value.replace(/[^\d]/g, '').replace(/(\d{1})(\d{2})$/, '$1.$2').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

    case 'ALPHA':
      return value.replace(/[0-9]/g, '');

    case 'EMAIL':
    default:
      return value;
  }
};

var doesNotMatchRegex = function doesNotMatchRegex(dataType, value) {
  return !dataTypes[dataType].match(value);
};

var isLessThanMinLength = function isLessThanMinLength(value, minLength) {
  return value.length !== 0 && value.length < minLength;
};

var isEmptyAndRequired = function isEmptyAndRequired(value, required) {
  return value.toString().length === 0 && required;
};

var getDefaultErrorMessage = function getDefaultErrorMessage(_ref) {
  var dataType = _ref.dataType,
      value = _ref.value,
      required = _ref.required,
      minLength = _ref.minLength,
      fieldName = _ref.fieldName;

  if (doesNotMatchRegex(dataType, value)) {
    return getString("error.dataType.".concat(dataType));
  } else if (isLessThanMinLength(value, minLength)) {
    return getString('error.minLength', minLength);
  } else if (isEmptyAndRequired(value, required)) {
    return getString('error.required', {
      fieldName: fieldName
    });
  } else {
    return '';
  }
};

var validateMessageIsLessThan40 = function validateMessageIsLessThan40(_ref2) {
  var message = _ref2.message,
      fieldName = _ref2.fieldName;
  return message.length > 40 ? message.replace(fieldName, 'this field') : message;
};

export var getErrorMessage = function getErrorMessage(_ref3) {
  var _ref3$dataType = _ref3.dataType,
      dataType = _ref3$dataType === void 0 ? 'ALL' : _ref3$dataType,
      _ref3$value = _ref3.value,
      value = _ref3$value === void 0 ? '' : _ref3$value,
      required = _ref3.required,
      minLength = _ref3.minLength,
      fieldName = _ref3.fieldName;
  var message = getDefaultErrorMessage({
    dataType: dataType,
    value: value,
    required: required,
    minLength: minLength,
    fieldName: fieldName
  });
  return message ? validateMessageIsLessThan40({
    message: message,
    fieldName: fieldName
  }) : '';
};